import React from 'react';
import useSWR from 'swr';
import { getProject } from '../../utils/woorankApi';
import { useUser } from './UserProvider';

interface ProjectContextValue {
  project?: object | null; // undefined means not loaded yet, null means no project exists yet
  loading: boolean;
  refresh: () => Promise<void>;
  // update: (apiKey: string) => Promise<void>
}
const ProjectContext = React.createContext<ProjectContextValue>({
  project: undefined,
  loading: false,
  refresh: async () => {}
});

type ProjectProviderProps = React.PropsWithChildren<{ url: string }>;

export function ProjectProvider ({ children, url }: ProjectProviderProps) {
  const { loading: userLoading, user } = useUser();

  const {
    data: projectData,
    error,
    mutate: refreshProject
  } = useSWR(user?.apiKey ? `/woorank-api/projects-internal/${url}` : null, () =>
    getProject(url, user!.apiKey)
  );

  const contextValue = {
    project: projectData,
    refresh: refreshProject,
    loading: userLoading || projectData === undefined
  };
  return (
    <ProjectContext.Provider value={contextValue}>
      <>
        {children}
      </>
    </ProjectContext.Provider>
  );
}

export function useProject (): ProjectContextValue {
  return React.useContext(ProjectContext);
}
